"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

function i18nKey(suffix) {
  return "FileManagerCore.shutterstock." + suffix;
}

var ShutterstockLicenseAgreement =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ShutterstockLicenseAgreement, _Component);

  function ShutterstockLicenseAgreement() {
    (0, _classCallCheck2.default)(this, ShutterstockLicenseAgreement);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShutterstockLicenseAgreement).apply(this, arguments));
  }

  (0, _createClass2.default)(ShutterstockLicenseAgreement, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          onAgree = _this$props.onAgree,
          onCancel = _this$props.onCancel;
      return _react.default.createElement(_UIModal.default, {
        width: 498,
        onOverlayClick: onClose
      }, _react.default.createElement(_UICloseButton.default, {
        className: "shutterstock-preview-modal__close-button",
        onClick: onClose
      }), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement("h2", null, _I18n.default.text(i18nKey('license.header')))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement("p", null, _react.default.createElement(_FormattedReactMessage.default, {
        message: i18nKey('license.termsOfUse'),
        options: {
          websiteTermsLink: _react.default.createElement(_UILink.default, {
            href: "https://www.shutterstock.com/terms",
            external: true
          }, _I18n.default.text(i18nKey('websiteTerms'))),
          privacyPolicyLink: _react.default.createElement(_UILink.default, {
            href: "https://www.shutterstock.com/privacy",
            external: true
          }, _I18n.default.text(i18nKey('privacyPolicy'))),
          licensingTermsLink: _react.default.createElement(_UILink.default, {
            href: "https://www.shutterstock.com/license",
            external: true
          }, _I18n.default.text(i18nKey('licensingTerms')))
        }
      }))), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
        use: "primary",
        onClick: onAgree
      }, _I18n.default.text(i18nKey('license.acceptButton'))), _react.default.createElement(_UIButton.default, {
        onClick: onCancel
      }, _I18n.default.text('FileManagerCore.actions.cancel'))));
    }
  }]);
  return ShutterstockLicenseAgreement;
}(_react.Component);

exports.default = ShutterstockLicenseAgreement;
ShutterstockLicenseAgreement.propTypes = {
  onAgree: _react.PropTypes.func.isRequired,
  onCancel: _react.PropTypes.func.isRequired,
  onClose: _react.PropTypes.func.isRequired
};
module.exports = exports.default;